// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const TagVehicleIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M20.88 11.64h-1.77c-.45 0-.81.36-.81.8s.36.81.8.81h1.78v2.09c0 .8-.63 1.43-1.43 1.43h-.17q.1.39.11.81t-.11.82v-.01h.17c1.68 0 3.05-1.37 3.05-3.05v-3.7c0-1.34-.79-2.55-2-3.06l-3.17-1.4v-.59c0-1.68-1.37-3.04-3.05-3.04H4.52C2.86 3.55 1.5 4.9 1.5 6.56v8.78c0 1.45 1.03 2.68 2.4 2.97q-.1-.35-.1-.73c0-1.59 1.29-2.87 2.87-2.87 1.59 0 2.87 1.28 2.87 2.87q0 .42-.11.81h4.33q-.1-.4-.11-.8c0-1.6 1.28-2.88 2.87-2.88q.42 0 .81.11V8.94l2.52 1.11c.64.27 1.03.9 1.03 1.58"
        opacity=".5"
      />
      <path
        fillRule="evenodd"
        d="M6.67 14.7C5.1 14.7 3.8 16 3.8 17.59s1.29 2.87 2.87 2.87c1.59 0 2.87-1.28 2.87-2.87s-1.28-2.87-2.87-2.87M5.42 17.6c0-.7.56-1.26 1.25-1.26.7 0 1.26.57 1.26 1.26s-.56 1.26-1.26 1.26-1.25-.57-1.25-1.26m11.1-2.9c-1.59 0-2.87 1.3-2.87 2.88 0 1.59 1.28 2.87 2.87 2.87s2.87-1.28 2.87-2.87-1.28-2.87-2.87-2.87m-1.26 2.88c0-.7.57-1.26 1.26-1.26s1.26.57 1.26 1.26-.57 1.26-1.26 1.26-1.26-.57-1.26-1.26"
      />
    </g>
  </SvgIcon>
);

export default TagVehicleIcon;
